import { render, staticRenderFns } from "./ProjectReadOnly.vue?vue&type=template&id=10b7b9e2&"
import script from "./ProjectReadOnly.vue?vue&type=script&lang=js&"
export * from "./ProjectReadOnly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports